const Quoting = () =>
    import("@/views/quoting/Quoting");

export const QuotingRoute = {
    path: "/quoting",
    component: Quoting,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",       
        breadcrumb: [
            {
                text: "Cotizadores",
                disabled: false,
                href: "#"
            }
        ],
        scope:["aps_broker","aps_executive","aps_promotor"]
    }
};